import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    show_product_enable_container: {
        display: 'flex',
        alignItems: 'center'
    },
    icon:{
        fontSize: '18px',
        marginRight: '4px'
    },
    text:{
        fontSize: '14px',
        fontWeight: 600,
    },
    active:{
        color: theme.palette.success.main,
    },
    inactive:{
        color: theme.palette.error.main,
    },
}));

export {useStyles}